module.exports = __webpack_public_path__ + "static/media/beneficiary-invite-image.e89abe24.jpg";